export default {
  'department.department': 'Dipartimento',
  'department.name': 'Nome Dipartimento',
  'department.perisanname': 'Nome del dipartimento persiano',
  'department.englishname': 'Nome del dipartimento inglese',
  'department.code': 'Codice Dipartimento',
  'department.add': 'Aggingi Dipartimento',
  'department.title': 'Direzione del reparto',
  'department.departmentdel': 'Cancella Dipartimento',
  'department.departmentadd': 'Dipartimento Aggiunto con Successo',
  'department.departmentdelete': 'Dipartimento Cancellato con Successo',
  'department.deleteerror': 'Il record è stato utilizzato da altri',
  'department.departmentaddInformation':
    'Le tue informazioni sono state modificate con successo',
};
